

import './signup.shop.component.js';
import './signup.shop.controller.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('signup.operator', {
    url: '/signup/operator',
    views: {
      '@': {
        component: 'inkSignupShop'
      }
    },
    resolve: {
      $title: (() => 'Add your shop to the Ink Finder Shop Network')
    },
    data: {
      authorizedRoles: [
        USER_ROLES.collector
      ]
    }
  });
});



// WEBPACK FOOTER //
// ./components/signup/shop/index.js